import React from "react";
import logo from "../assets/webLogo.png";
import styled from "styled-components";
import { NavLink, Outlet } from "react-router-dom";
const NavBar = () => {
  return (
    <>
      <Container>
        <div className="logoSection">
          <img src={logo} alt="Logo" />
          <span>Chatify</span>
        </div>

        <div className="route-content">
          <ul>
            <li>
              <NavLink to="/">Home</NavLink>
            </li>
            <li>
              <NavLink to="/setavatar">SetAvatar</NavLink>
            </li>
            <li>
              <NavLink to="/login">Login</NavLink>
            </li>
            <li>
              <NavLink to="/register">Register</NavLink>
            </li>
          </ul>
        </div>
      </Container>
      <Outlet />
    </>
  );
};

const Container = styled.div`
position: absolute;
top: 0;
width: 100vw;
height: 50px;
background-color:#483c4830;
display:grid;
align-items:center;
grid-template-columns:20% 80%;
overflow: hidden;

.logoSection{
    display:flex;
    justify-content:center;
    img{
        height:2rem;
    }
    span{
        font-size:1.3rem;
        color:white;
    }
}

.route-content{
    display:flex;
    justify-content:flex-end;
    ul{
        display:flex;
        margin:0;
        margin-right:20px;
        li{
            list-style:none;
            margin: 0 12px;
            a{
                text-decoration:none;
                color:white;
                padding:4px 0px;
                transition:0.2s;
            }
            a:hover,.active{
                border-bottom:2px solid #fff;
            }
        }
    }
}

@media screen and (max-width: 1080px) {
    .logoSection{
        img,span{
            display: none;
        }
    }
    .route-content{
        justify-content:center;
    }
}

@media screen and (max-width: 460px) {
    grid-template-columns:100%;
    .logoSection{
        display: none;
    }
    .route-content{
        ul{
            margin: 0;
            padding: 0;
            li{
                margin: 0 10px;
                a{
                    font-size:.9rem;
                }
            }
        }
    }
}
`;

export default NavBar;
